'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dSeed$002dToken from "./presto.-Two-Factor-Auth-View$-Seed-Token.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$SeedToken$() {
}
export { $c_Lpresto_TwoFactorAuthView$SeedToken$ as $c_Lpresto_TwoFactorAuthView$SeedToken$ };
$p = $c_Lpresto_TwoFactorAuthView$SeedToken$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$SeedToken$;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$SeedToken$() {
}
export { $h_Lpresto_TwoFactorAuthView$SeedToken$ as $h_Lpresto_TwoFactorAuthView$SeedToken$ };
$h_Lpresto_TwoFactorAuthView$SeedToken$.prototype = $p;
$p.l = (function() {
  return "SeedToken";
});
$p.cGa = (function(x$0) {
  return new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dSeed$002dToken.$c_Lpresto_TwoFactorAuthView$SeedToken(x$0.j(0));
});
var $d_Lpresto_TwoFactorAuthView$SeedToken$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$SeedToken$, "presto.TwoFactorAuthView$SeedToken$", ({
  TJ: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_TwoFactorAuthView$SeedToken$ as $d_Lpresto_TwoFactorAuthView$SeedToken$ };
var $n_Lpresto_TwoFactorAuthView$SeedToken$;
function $m_Lpresto_TwoFactorAuthView$SeedToken$() {
  if ((!$n_Lpresto_TwoFactorAuthView$SeedToken$)) {
    $n_Lpresto_TwoFactorAuthView$SeedToken$ = new $c_Lpresto_TwoFactorAuthView$SeedToken$();
  }
  return $n_Lpresto_TwoFactorAuthView$SeedToken$;
}
export { $m_Lpresto_TwoFactorAuthView$SeedToken$ as $m_Lpresto_TwoFactorAuthView$SeedToken$ };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Seed-Token$.js.map
